const EXTENDED_CATALOG_EDITOR_OPTIONS = ["childCount"];
export const extend_CATALOG_EDITOR_OPTIONS = (options: string[]) =>
  [...options, ...EXTENDED_CATALOG_EDITOR_OPTIONS].filter(
    (el) => el !== "subcatalogCount"
  );
